import { appStoreBannerStore } from "@/store/app-store-banner";
import { isMobileBrowser } from "@/utils/browserUtil";

class AppStoreBannerService {
  /**
   * アプリストアバナーを表示するべきかを返す
   * 以下の条件を満たすときにバナーが表示される
   * * ブラウザである
   * * モバイル環境で開かれている(ユーザーエージェントがiPhone, iPad, iPod, Androidである)
   * * そのセッションでバナーを閉じていない
   */
  shouldShownBanner() {
    return isMobileBrowser() && !appStoreBannerStore.haveAlreadySeenBanner;
  }

  /**
   * アプリストアバナーを閉じたら記録する
   */
  haveAlreadySeenBanner() {
    appStoreBannerStore.setHaveAlreadySeenBanner();
  }
}

export const appStoreBannerService = new AppStoreBannerService();
